import { SITE_NAME } from './config';

export interface HeadMeta {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  type: 'website' | 'article';
  imageUrl?: string;
  noindex?: boolean;
}

function upsertMeta(
  attr: 'name' | 'property',
  key: string,
  content: string,
): void {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  );
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function removeMeta(attr: 'name' | 'property', key: string): void {
  const el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  );
  if (el) {
    el.remove();
  }
}

function upsertCanonical(href: string): void {
  let el = document.head.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]',
  );
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function applyHead(meta: HeadMeta): void {
  document.title = meta.title;

  upsertMeta('name', 'description', meta.description);
  upsertMeta('name', 'keywords', meta.keywords);
  upsertCanonical(meta.canonicalUrl);

  upsertMeta('property', 'og:title', meta.title);
  upsertMeta('property', 'og:description', meta.description);
  upsertMeta('property', 'og:type', meta.type);
  upsertMeta('property', 'og:url', meta.canonicalUrl);
  upsertMeta('property', 'og:site_name', SITE_NAME);

  if (meta.imageUrl) {
    upsertMeta('property', 'og:image', meta.imageUrl);
    upsertMeta('name', 'twitter:image', meta.imageUrl);
  } else {
    removeMeta('property', 'og:image');
    removeMeta('name', 'twitter:image');
  }

  upsertMeta(
    'name',
    'twitter:card',
    meta.imageUrl ? 'summary_large_image' : 'summary',
  );
  upsertMeta('name', 'twitter:title', meta.title);
  upsertMeta('name', 'twitter:description', meta.description);

  if (meta.noindex) {
    upsertMeta('name', 'robots', 'noindex, nofollow');
  } else {
    removeMeta('name', 'robots');
  }
}